export type PayoneerCheckoutSdkVersion = 'legacy' | 'web';

export const PAYONEER_CHECKOUT_SDK_VERSION: PayoneerCheckoutSdkVersion =
  process.env.NEXT_PUBLIC_PAYONEER_CHECKOUT_SDK_VERSION === 'web'
    ? 'web'
    : 'legacy';

// Legacy SDK (op-payment-widget-v3 / SELECTIVE_NATIVE) DOM ids
export const payButtonId = 'submitBtnId';
export const payButtonContainerId = 'submitBtnContainerId';
export const paymentNetworksId = 'paymentNetworksId';

// New Web SDK (@payoneer/checkout-web / EMBEDDED) mount node id
export const paymentContainerId = 'paymentContainerId';

export const PAYONEER_CHECKOUT_WEB_ENV: 'live' | 'test' =
  process.env.NEXT_PUBLIC_PAYONEER_CHECKOUT_ENV === 'live' ? 'live' : 'test';

export const PAYONEER_CHECKOUT_WEB_SDK_VERSION = '1.24.0';

export const PAYONEER_CHECKOUT_WEB_SDK_URL =
  PAYONEER_CHECKOUT_WEB_ENV === 'live'
    ? `https://checkout.payoneer.com/web/libraries/checkout-web/umd/checkout-web-${PAYONEER_CHECKOUT_WEB_SDK_VERSION}.min.js`
    : `https://resources.sandbox.oscato.com/web/libraries/checkout-web/umd/checkout-web-${PAYONEER_CHECKOUT_WEB_SDK_VERSION}.min.js`;

export const PAYONEER_CHECKOUT_WEB_SDK_INTEGRITY =
  'sha384-RasB8+PBTxrEsz9sv6NFhrwLDAJfN9awQiY1VDizu9r6BUy37coVraXNZAYhbbmO';
